(function (ws) {
    'use strict';
    ws.views.physicalProductsTable = ws.views.staticTable.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'order_activity',
        GTM_EVENT_ACTION_CARRIER_TRACKING: 'carrier tracking',
        GTM_EVENT_ACTION_INVOICE_LINK: 'invoice pdf',
        GTM_EVENT_ACTION_INFORMATION_ICON: 'information tooltip',
        GTM_EVENT_ACTION_PACKING_SLIP: 'packing_slip',
        GTM_EVENT_ACTION_PACKING_SLIP_LABEL: 'order_detail_click_packing_slip_number',
        GTM_EVENT_CARRIER_TRACKING_CATEGORY: 'order_activity',
        GTM_EVENT_ACTION_PDF_CARRIER_TRACKING: 'proof_of_delivery_pdf',

        /**
         * initialize override
         */
        initialize: function() {
            this.$table = this.$('#physical-products-table');
            this.$hideColumn = $.trim(this.$('.ppt-hide-column').html());

            this.responsivePriority = [
                { responsivePriority: 1 },
                { responsivePriority: 1 },
                { responsivePriority: 1 },
                { responsivePriority: 1 },
                { responsivePriority: 1 },
                { responsivePriority: 1 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 3 },
                { responsivePriority: 3 },
                { responsivePriority: 3 },
                { responsivePriority: 3 },
                { responsivePriority: 4 },
                { responsivePriority: 4 },
                { responsivePriority: 4 },
                { responsivePriority: 4 },
                { responsivePriority: 4 }
            ];

            // remove 5th column
            if (this.$hideColumn === 'true') {
                this.responsivePriority.splice(5, 1);
            }

            this.columnDefs = [
                {
                    targets: [-1, -2, -3],
                    className: 'none'
                }
            ];

            this.stripeClasses = ['odd'];
            this.emptyTableError = this.$el.data('emptyTableError');

            //make sure tracking number column has higher priority
            var indexOfTrackingCol = this.$table.find('th.ppt-tracking').index();
            this.responsivePriority[indexOfTrackingCol].responsivePriority = 1;

            ws.views.staticTable.prototype.initialize.call(this);
            this.notes = $('.physicalDataNotes');
            this.dhlStatus();
            if (this.$('.hasDeliveryStatus').val() === 'true') {
                let dataArray = [];
                if (this.$('#physical-products-table').dataTable().fnSettings().aoData.length) {
                    let trackIds = [];
                    _.each($('#physical-products-table').find('tr.odd'), function (element, index) {
                        _.each($(element).find('.viewCarrierTrackingButton'), function (ele) {
                            let tractId = $(ele).data('attr');
                            trackIds.push(tractId);
                        });
                    });

                    let data = {
                        trackingDetails: trackIds
                    };

                    if (trackIds.length > 0) {
                        let orderModel = new ws.models.physicalProductsStatus({
                            sapId: $('#pdfData').data('orderNumber'),
                            csrfToken: window.CSRFToken
                        });

                        orderModel.save(data).done(function (res) {
                            let trackIndex = 0;
                            _.each($('#physical-products-table').find('tr.odd'), function (element, index) {
                                if ($(element).find('.viewCarrierTrackingButton')) {
                                    let info = '';
                                    _.each($(element).find('.viewCarrierTrackingButton'), function (ele) {

                                        let trackingInfo = res.trackingDetails[trackIndex];

                                        if (trackingInfo.length === 0) {
                                            info += '';
                                        } else {
                                            if (trackingInfo.deliveryStatus !== null) {
                                                let status = $(element).find('.statusCode').data('attr');
                                                if (trackingInfo.deliveryStatus === 'NA') {
                                                    switch (status) {
                                                        case 'INV':
                                                            info += $(element).find('.orderStatus').data('delInv');
                                                            break;
                                                        case 'SCH':
                                                            info += $(element).find('.orderStatus').data('delSch');
                                                            break;
                                                        case 'REG':
                                                            info += '';
                                                            break;
                                                        default:
                                                            info += $(element).find('.orderStatus').data('delDefault');
                                                            break;
                                                    }
                                                } else {
                                                    let lastIndex = trackingInfo.deliveryStatus.lastIndexOf(',');
                                                    let s1 = trackingInfo.deliveryStatus.substring(0, lastIndex);
                                                    let s2 = trackingInfo.deliveryStatus.substring(lastIndex + 1);
                                                    info += '<p>' + s1 + '</p><p class="noWrap">' + s2 + '</p>' + '&#13;&#10;';
                                                }

                                                info += '<br />';
                                            }
                                        }

                                        trackIndex++;
                                    });
                                    $(element).find('.orderStatus').html(info);
                                } else {
                                    if ($(element).find('.statusCode').data('catType') != 'TAS') {
                                        let info = '';
                                        let status = $(element).find('.statusCode').data('attr');
                                        switch (status) {
                                            case 'INV':
                                                info = $(element).find('.orderStatus').data('delInv');
                                                break;
                                            case 'SCH':
                                                info = $(element).find('.orderStatus').data('delSch');
                                                break;
                                            case 'REG':
                                                info = '';
                                                break;
                                            default:
                                                info = $(element).find('.orderStatus').data('delDefault');
                                                break;
                                        }
                                        $(element).find('.orderStatus').html(info);
                                    }
                                }
                            });
                        });
                    }
                }
            }
        },

        events: _.extend({}, ws.views.staticTable.prototype.events, {
            'click a.openNotes': 'showNote',
            'click .trackingLink': 'handleTrackingLinkClick',
            'click .invoiceLink': 'handleInvoiceLinkClick',
            'click .order-packingSlipLink': 'handlePackingSlipClick',
            'mouseenter .physical-order': 'trackingInformationIcon',
            'click .viewCarrierTrackingButton': 'handleCarrierTrackingButtonEvent',
            'click .viewCarrierTrackingButtonPdf': 'handleCarrierTrackingPdfButtonEvent'
        }),

        /**
         * Fires analytics event when user clicks on carrier tracking button
         */
        handleCarrierTrackingButtonEvent () {
            this.gtmEventTracking(this.GTM_EVENT_CARRIER_TRACKING_CATEGORY, this.GTM_EVENT_ACTION_CARRIER_TRACKING);
            _satellite.track('event:order:carrierTracking');
        },

        dhlStatus: function () {
            const arr = [];
            let ele = $('.viewCarrierTrackingButton');
            let apiCallRequired = false;
            for (let i = 0; i < ele.length; i++) {
                let elements = ele[i];
                if ($('#carriersForApiCall').val().includes($(elements).data('carriertype').toUpperCase())) {
                    let obj = {carrier: $(elements).data('carriertype'),
                        orderNumber: $(elements).data('salesordernumber'),
                        trackingNumber: $(elements).data('carrierTrackingNum').toString()};
                    arr.push(obj);
                    apiCallRequired = true;
                } else {
                    let obj = {carrier: $(elements).data('carriertype'),
                        orderNumber: '',
                        trackingNumber: $(elements).data('carrierTrackingNum').toString()};
                    arr.push(obj);
                }
            }

            if (apiCallRequired) {
                globals.disableApp();
                $.ajax({
                    url: `${sitePath}/pod/tracking/status?${CSRF}`,
                    contentType: 'application/json',
                    data: JSON.stringify({tracking: arr}),
                    method: 'POST'
                }).done(res => {
                    globals.enableApp();
                    if (res.length) {
                        res.forEach((item, i) => {
                            if (!item.status || item.status === 'Shipment Not Found') {
                                $(ele[i]).removeAttr('data-event');
                                $(ele[i]).html('');
                                $(`<span>${item.trackingNumber}</span>`).insertAfter(ele[i]);
                            } else {
                                if ($(ele[i]).data('salesordernumber') === item.orderNumber && item.status === 'Delivered' && $('#carriersForApiCall').val().includes(item.carrier.toUpperCase())) {
                                    console.log('Comment added to remove gulp warnings');
                                } else if ($('#carriersForApiCall').val().includes(item.carrier.toUpperCase()) && item.status) {
                                    $(ele[i]).removeAttr('data-event');
                                    $(ele[i]).html('');
                                    $(`<span>${item.trackingNumber}-In Processing</span>`).insertAfter(ele[i]);
                                }
                            }
                        });
                    }
                }).fail(function (response) {
                    globals.enableApp();
                    console.error(response);
                }.bind(this));
            }
        },

        /**
         * Fires analytics event when user clicks on carrier tracking pdf
         */
        handleCarrierTrackingPdfButtonEvent () {
            this.gtmEventTracking(this.GTM_EVENT_CARRIER_TRACKING_CATEGORY, this.GTM_EVENT_ACTION_PDF_CARRIER_TRACKING);
            _satellite.track('event:order:carrierTracking');
        },

        /**
         * Overriding styleChildTr
         */
        styleChildTr: function(e) {
            const tr = $(e.currentTarget).closest('tr');
            const childTr = $(tr).next();

            if ($(childTr).hasClass('child')) {
                $(childTr).removeClass('parent');
            }

            if ($(childTr).hasClass('child') && ($(tr).hasClass('last-row') || $(tr).hasClass('single-line-status'))) {
                $(childTr).addClass('last-row');
                $(tr).removeClass('last-row');
            } else if (!$(tr).hasClass('last-row') && !$(tr).hasClass('final-row') && !$(tr).hasClass('single-row')) {
                $(tr).addClass('last-row');
            }
        },

        /**
         * Show Data on notes modal
         */
        showNote: function (e) {
            this.notes.html($(e.currentTarget).data('attr'));
        },

        /**
         * Handle tracking link click and trigger analytics event
         *
         * @param {Object} e
         */
        handleTrackingLinkClick (e) {
            e.preventDefault();
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION_CARRIER_TRACKING);
            _satellite.track('event:order:carrierTrackingProofDelivery');
            window.open($(e.currentTarget).attr('href'), '_blank');
        },

        /**
         * Handle invoice link click and trigger analytics event
         *
         */
        handleInvoiceLinkClick () {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION_INVOICE_LINK);
            _satellite.track('event:order:invoices');
        },

        /**
         * Handle packing slip number click and trigger analytics event
         *
         */
        handlePackingSlipClick () {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION_PACKING_SLIP, this.GTM_EVENT_ACTION_PACKING_SLIP_LABEL);
            _satellite.track('event:order:viewPackingSlips');
        },

        /**
         * Track information icon event
         */
        trackingInformationIcon () {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION_INFORMATION_ICON);
        }

    });
}(westcon));
